import { render } from "./PrintSticker.vue?vue&type=template&id=b79e9194"
import script from "./PrintSticker.vue?vue&type=script&lang=js"
export * from "./PrintSticker.vue?vue&type=script&lang=js"

import exportComponent from "/builds/it60371727/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__